import React, { useCallback } from 'react'
import { Stack, MenuItem, Button, Menu } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { useTranslation } from 'react-i18next'
import { Profile } from '../../types/profile'
import MenuItemField from '../fields/MenuItemField'
import { CheckBoxOutlineBlank, KeyboardArrowDown } from '@mui/icons-material'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import { MachineSlot } from '../../types/machineslot'
import { useContextHook } from '../../store/context'
interface profileBulkOpProps {
  selectedProfiles: Profile[]
  machineSlots: MachineSlot[]
  handleUncheck(): void
  handleAssign(): void
  handleUnassign(): void
  handleDelete(): void
}

const ProfileBulkOp = (props: profileBulkOpProps): JSX.Element => {
  const { t } = useTranslation()
  const { state } = useContextHook()
  const [open, setOpen] = React.useState<boolean>(false)
  const [renderUnassign, setRenderUnassign] = React.useState<boolean>(false)
  const [canAssign, setCanAssign] = React.useState<boolean>(false)
  const [canUnassign, setCanUnssign] = React.useState<boolean>(false)

  const renderUnassignCheck = useCallback(() => {
    const assigned = props.machineSlots.find((x) => x.requested_profile === props.selectedProfiles[0]?.url)
    if (props.selectedProfiles[0]?.url === state.currentMachine?.bbp_profile?.url || assigned !== undefined) {
      setRenderUnassign(true)
    } else {
      setRenderUnassign(false)
    }
  }, [props.selectedProfiles, props.machineSlots, state.currentMachine?.bbp_profile])

  const canUnassignCheck = useCallback(() => {
    const unassign = props.selectedProfiles.every(
      (p) =>
        props.machineSlots.find((x) => x.requested_profile === p.url) ||
        p.url === state.currentMachine?.bbp_profile?.url
    )
    setCanUnssign(unassign)
  }, [props.selectedProfiles, props.machineSlots, state.currentMachine?.bbp_profile])

  const canAssignCheck = useCallback(() => {
    const assign = props.selectedProfiles.every(
      (p) =>
        !props.machineSlots.find((x) => x.requested_profile === p.url) &&
        state.currentMachine?.bbp_profile?.url !== p.url
    )
    setCanAssign(assign)
  }, [props.selectedProfiles, props.machineSlots, state.currentMachine?.bbp_profile])

  React.useEffect(() => {
    renderUnassignCheck()
    canUnassignCheck()
    canAssignCheck()
  }, [props.selectedProfiles, renderUnassignCheck, canUnassignCheck, canAssignCheck])

  return (
    <Stack direction={'row-reverse'}>
      <Button
        onClick={() => setOpen(true)}
        id="bulk_op"
        sx={{
          textTransform: 'capitalize',
          minWidth: 'auto',
        }}
        endIcon={<KeyboardArrowDown />}
        variant="contained"
      >
        {t('logview.bulkoperations')}
      </Button>
      <Menu open={open} onClose={() => setOpen(false)} anchorEl={document.getElementById('bulk_op')}>
        {!renderUnassign && (
          <MenuItem
            onClick={() => {
              props.handleAssign()
              setOpen(false)
            }}
            sx={{ minWidth: 200 }}
            disabled={props.selectedProfiles.length <= 0 || !canAssign}
          >
            <MenuItemField label={t('profilesview.assign')} icon={<FileUploadIcon sx={{ mr: 2.5 }} />} />
          </MenuItem>
        )}
        {!!renderUnassign && (
          <MenuItem
            onClick={() => {
              props.handleUnassign()
              setOpen(false)
            }}
            disabled={props.selectedProfiles.length <= 0 || !canUnassign}
          >
            <MenuItemField
              label={t('profilesview.unassign')}
              icon={<FileUploadIcon sx={{ mr: 2.5, transform: 'rotate(180deg)' }} />}
            />
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            props.handleUncheck()
            setOpen(false)
          }}
          disabled={props.selectedProfiles.length < 1}
        >
          <MenuItemField label={t('logview.unselectall')} icon={<CheckBoxOutlineBlank sx={{ mr: 2.5 }} />} />
        </MenuItem>
        <MenuItem
          onClick={() => {
            props.handleDelete()
            setOpen(false)
          }}
          disabled={props.selectedProfiles.length <= 0}
        >
          <MenuItemField label={t('logview.delete')} icon={<DeleteIcon sx={{ mr: 2.5 }} />} />
        </MenuItem>
      </Menu>
    </Stack>
  )
}
export default ProfileBulkOp
